export default __webpack_public_path__ + "static/ep_mobile-6aee753a8ee239aa707ef961cb22b884.png";